module.exports = __webpack_public_path__ + "img/works_kbstar_btm.94e29ebf.jpg";